import React, { useEffect, useState } from 'react';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Polls /version.json (emitted at build) and compares it to the sha baked into
 * this bundle. When they diverge a deploy has happened since this tab loaded —
 * SPAs never pick that up on their own, so surface a reload prompt instead of
 * letting users run a stale build without knowing.
 */
const UpdateBanner: React.FC = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const v = await res.json();
        if (!cancelled && v?.sha && v.sha !== __BUILD_SHA__) setUpdateAvailable(true);
      } catch {
        // Offline or version.json not deployed yet — stay quiet
      }
    };

    const id = setInterval(check, CHECK_INTERVAL_MS);
    window.addEventListener('focus', check);
    check();
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener('focus', check);
    };
  }, []);

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-anchor-navy/95 backdrop-blur-sm border border-anchor-blue/40 rounded-lg px-4 py-2.5 shadow-2xl">
      <span className="text-sm text-white">A new version of Data Anchor is available.</span>
      <button
        onClick={() => window.location.reload()}
        className="px-3 py-1 rounded-md bg-anchor-blue/20 text-anchor-blue text-sm font-medium hover:bg-anchor-blue/30 transition-colors"
      >
        Reload
      </button>
    </div>
  );
};

export default UpdateBanner;
